<script setup>
defineProps(['model'])
</script>

<template>
  <div
    class="block-spacing relative w-full"
    :class="{ 'bg-med-light-aqua pt-10 pb-15 lg:pt-15 lg:pb-21 icon-grid-block--background': model?.greyMode?.value === true }"
  >
    <div class="container-fluid">
      <div
        v-if="model?.title?.value || model?.body?.value"
        class="prose w-full eight-col-max ml-auto mr-auto relative"
      >
        <h2 v-if="model?.title?.value">
          {{ model.title.value }}
        </h2>
        <div
          v-if="model?.body?.value"
          v-html="model.body.value"
        />
      </div>
      <div
        v-if="model?.icons?.expandedValue"
        class="icon-card-grid container-text eight-col-max ml-auto mr-auto relative"
      >
        <div
          v-for="icon in model.icons.expandedValue"
          :key="icon.name"
          class="icon-card"
        >
          <IconBlock
            :model="icon"
            :image-size="model.imageSize?.value"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@use '@/assets/css/blocks/icon-grid-block.scss';
</style>
